/**
 * 小牛网页翻译鉴权配置（对齐 NiuTransWebPlugin）
 *
 * 流程：登录 -> getRealmAndLanguage -> batchTrans
 * 性能：去重文案、并行批次、先译首屏再揭遮罩、本地缓存译文
 */
export default {
  // 实际服务：http://222.175.152.42:8091 （本地请用代理，避免跨域）
  ipAddress: '',
  username: 'sunther',
  password: 'Sunther123.',
  token: '',
  apikey: '',
  termId: '',
  memoryId: '',
  /** 指定领域 realmId；留空=自动匹配中译英方向 */
  area: '',
  sourceLanguage: 'zh',
  targetLanguage: 'en',
  /** 每批文本条数 */
  batchSize: 15,
  /** 单次 batchTrans 最大字符数（超过会拆批，避免接口报超限） */
  maxBatchChars: 2000,
  /** 同时发起的翻译请求数 */
  concurrency: 3,
  /** 路由切换后等待渲染再译 */
  routeDelay: 200,
  /** DOM 变化补翻防抖（已先同步刷缓存） */
  observerDelay: 250,
  /** 首次采不到文本时的短等待 */
  collectRetryDelay: 100,
};